import LeaderCard from '@/components/LeaderCard'
import styles from './LeadershipGrid.module.scss'

// Editors control the arrangement from WordPress through each leader page's Order field,
// using the tens digit as the row and the units as the position within it — 10/11 is a
// row of two, 20/21/22 a row of three. That keeps the 2/3/2 shape in the design out of
// this file: moving someone between rows, reordering a row, or adding a fourth row is
// just editing numbers in wp-admin.
const ROW_SIZE = 10

// The query already returns leaders ordered by menuOrder ascending, so pushing in order
// preserves each row's internal sequence.
function groupIntoRows(leaders) {
  const rows = new Map()

  leaders.forEach((leader) => {
    const row = Math.floor((leader?.menuOrder ?? 0) / ROW_SIZE)
    if (!rows.has(row)) {
      rows.set(row, [])
    }
    rows.get(row).push(leader)
  })

  return [...rows.entries()].sort(([a], [b]) => a - b).map(([, leaders]) => leaders)
}

export default function LeadershipGrid({ leaders }) {
  const rows = groupIntoRows((leaders ?? []).filter(Boolean))

  if (rows.length === 0) {
    return null
  }

  return (
    <section className={styles.leadershipGrid} data-aos="fade-up">
      {rows.map((row, rowIndex) => (
        <div className={styles.row} key={row[0]?.id ?? rowIndex}>
          {row.map((leader) => (
            <div className={styles.cell} key={leader.id ?? leader.uri}>
              <LeaderCard
                name={leader.title}
                title={leader.leaderFields?.role}
                headshot={leader.featuredImage}
                // `href` rather than `slug`: the page's own uri is already the full
                // /leadership/<slug>/ path, so passing the slug would double the prefix.
                href={leader.uri}
                sizes="(max-width: 768px) 90vw, 400px"
                // Only the first row is above the fold on any realistic viewport.
                priority={rowIndex === 0}
              />
            </div>
          ))}
        </div>
      ))}
    </section>
  )
}
